export enum SolutionSlug {
	AerospaceAndDefense = "AerospaceAndDefense",
	ThirdPartyLogistics = "ThirdPartyLogistics",
	Retail = "Retail",
	ParcelServices = "ParcelServices",
	Healthcare = "Healthcare",
	IndustrialDistribution = "IndustrialDistribution",
	FoodAndBeverage = "FoodAndBeverage",
	ManufacturingLogistics = "ManufacturingLogistics",

	AgvAndAmr = "AgvAndAmr",
	AsRs = "AsRs",
	CubicStorageSystem = "CubicStorageSystem",
	ConveyorSystems = "ConveyorSystems",
	GoodsToPersonTechnology = "GoodsToPersonTechnology",
	AutomatedPackagingTechnology = "AutomatedPackagingTechnology",
	Picking = "Picking",
	Robotization = "Robotization",
	SortingSystems = "SortingSystems",
	ControlSoftware = "ControlSoftware",
	VerticalTowerSystems = "VerticalTowerSystems",

	ParcelSorting = "ParcelSorting",
	PackagingAndDelivery = "PackagingAndDelivery",
	Fulfillment = "Fulfillment",
	HighDensityStorage = "HighDensityStorage",
	Ecommerce = "Ecommerce",
	CrossDockingAndReturns = "CrossDockingAndReturns",
	CentralAndLastMileWarehouses = "CentralAndLastMileWarehouses",
	MicroFulfillment = "MicroFulfillment",
}
